var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_281_13102)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EADDFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30 16.81V22.9L28.37 21.5C27.59 20.83 26.33 20.83 25.55 21.5L21.39 25.07C20.61 25.74 19.35 25.74 18.57 25.07L18.23 24.79C17.52 24.17 16.39 24.11 15.59 24.65L10.67 27.95L10.56 28.03C10.19 27.23 10 26.28 10 25.19V16.81C10 13.17 12.17 11 15.81 11H24.19C27.83 11 30 13.17 30 16.81Z",
    fill: "#6A639C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 19.38C18.3146 19.38 19.3801 18.3144 19.3801 17C19.3801 15.6856 18.3146 14.62 17.0001 14.62C15.6857 14.62 14.6201 15.6856 14.6201 17C14.6201 18.3144 15.6857 19.38 17.0001 19.38Z",
    fill: "#6A639C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9996 22.9001V25.1901C29.9996 28.8301 27.8296 31.0001 24.1896 31.0001H15.8096C13.2596 31.0001 11.4196 29.9301 10.5596 28.0301L10.6696 27.9501L15.5896 24.6501C16.3896 24.1101 17.5196 24.1701 18.2296 24.7901L18.5696 25.0701C19.3496 25.7401 20.6096 25.7401 21.3896 25.0701L25.5496 21.5001C26.3296 20.8301 27.5896 20.8301 28.3696 21.5001L29.9996 22.9001Z",
    fill: "#6A639C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_281_13102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.e2d88309fa983b4663d04c9b902e9cbc.svg";
export { ForwardRef as ReactComponent };